import { useEffect } from 'react';
import { toast } from 'sonner';

import { useUpdateAvailable } from '@/hooks/useUpdateAvailable';

export function UpdateAvailable() {
  const { updateAvailable, updateServiceWorker } = useUpdateAvailable();

  useEffect(() => {
    if (!updateAvailable) return;

    toast('Nova versão disponível', {
      description: 'Uma atualização do JurisApp está pronta.',
      duration: Infinity,
      action: {
        label: 'Atualizar',
        onClick: () => updateServiceWorker(),
      },
    });
  }, [updateAvailable, updateServiceWorker]);

  return null;
}

export default UpdateAvailable;
